// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ConfirmationModal_wrapper__tbzBb","content":"ConfirmationModal_content__1vy5f"};